<template>
  <BasePopup ref="popup" title="Delete Highlight" class="popup--simple">
    <div>
      <p>Are you sure you want to delete this highlight?</p>
      <div class="cancel-form__group--submit">
        <button
          class="cancel-form__close-btn btns btns--largest btns--font-large btns--full"
          @click="hide"
        >
          Cancel
        </button>
        <button
          class="cancel-form__btn btns btns--largest btns--font-large btns--red btns--full"
          @click="confirmDeletion"
        >
          Delete
        </button>
      </div>
    </div>
  </BasePopup>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import BasePopup from '@/components/ui/BasePopup.vue'
import { AnnotationView } from '@/models/doc'

const emit = defineEmits<{
  (e: 'confirmDelete', value: AnnotationView): void
}>()

const popup = ref<InstanceType<typeof BasePopup> | null>(null)

const highlight = ref<AnnotationView | undefined>(undefined)

function show(_highlight: AnnotationView): void {
  highlight.value = _highlight
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

function confirmDeletion(): void {
  emit('confirmDelete', highlight.value as AnnotationView)
  hide()
}

defineExpose({
  show,
  hide,
})
</script>
